const MuiTypographyOverrides = {
  MuiTypography: {
    defaultProps: {
      variantMapping: {
        displayExtraLarge: 'h1',
        displayLarge: 'h2',
        displayMedium: 'h3',
        displaySmall: 'h4',
        heading: 'h5',
        subheader: 'h6',
        body01: 'span',
        body02: 'span',
        caption: 'span'
      }
    }
  }
};

export { MuiTypographyOverrides };
